export default __webpack_public_path__ + "static/media/blog-xl-3.7c141f4e.png";